'use strict';

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var escapeStringRegexp = require('escape-string-regexp');

var transliterate = require('@sindresorhus/transliterate');

var builtinOverridableReplacements = require('./overridable-replacements');

var decamelize = function decamelize(string) {
  return string // Separate capitalized words.
  .replace(/([A-Z]{2,})(\d+)/g, '$1 $2').replace(/([a-z\d]+)([A-Z]{2,})/g, '$1 $2').replace(/([a-z\d])([A-Z])/g, '$1 $2').replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1 $2');
};

var removeMootSeparators = function removeMootSeparators(string, separator) {
  var escapedSeparator = escapeStringRegexp(separator);
  return string.replace(new RegExp("".concat(escapedSeparator, "{2,}"), 'g'), separator).replace(new RegExp("^".concat(escapedSeparator, "|").concat(escapedSeparator, "$"), 'g'), '');
};

var slugify = function slugify(string, options) {
  if (typeof string !== 'string') {
    throw new TypeError("Expected a string, got `".concat(_typeof(string), "`"));
  }

  options = _objectSpread({
    separator: '-',
    lowercase: true,
    decamelize: true,
    customReplacements: [],
    preserveLeadingUnderscore: false
  }, options);
  var shouldPrependUnderscore = options.preserveLeadingUnderscore && string.startsWith('_');
  var customReplacements = new Map([].concat(_toConsumableArray(builtinOverridableReplacements), _toConsumableArray(options.customReplacements)));
  string = transliterate(string, {
    customReplacements: customReplacements
  });

  if (options.decamelize) {
    string = decamelize(string);
  }

  var patternSlug = /[^a-zA-Z\d]+/g;

  if (options.lowercase) {
    string = string.toLowerCase();
    patternSlug = /[^a-z\d]+/g;
  }

  string = string.replace(patternSlug, options.separator);
  string = string.replace(/\\/g, '');

  if (options.separator) {
    string = removeMootSeparators(string, options.separator);
  }

  if (shouldPrependUnderscore) {
    string = "_".concat(string);
  }

  return string;
};

var counter = function counter() {
  var occurrences = new Map();

  var countable = function countable(string, options) {
    string = slugify(string, options);

    if (!string) {
      return '';
    }

    var stringLower = string.toLowerCase();
    var numberless = occurrences.get(stringLower.replace(/(?:-\d+?)+?$/, '')) || 0;
    var counter = occurrences.get(stringLower);
    occurrences.set(stringLower, typeof counter === 'number' ? counter + 1 : 1);
    var newCounter = occurrences.get(stringLower) || 2;

    if (newCounter >= 2 || numberless > 2) {
      string = "".concat(string, "-").concat(newCounter);
    }

    return string;
  };

  countable.reset = function () {
    occurrences.clear();
  };

  return countable;
};

module.exports = slugify;
module.exports.counter = counter;